export default __webpack_public_path__ + "static/media/Tipp_Rechteck.e80a02ab.png";